import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface VehiclesState {}

const initialState: any = {
  vehicles: [],
};

export const ormvehiclesSlice = createSlice({
  name: "ormvehicles",
  initialState,
  reducers: {
    setVehicles: (state, action: PayloadAction<any[]>) => {
      state.vehicles = action.payload;
    },
  },
});

export const { setVehicles } = ormvehiclesSlice.actions;

export default ormvehiclesSlice.reducer;
